<template>
    <div>
        Inversores
    </div>
</template>